<template>
  <cd-layout>
    <template #page-title>
      Authentication
    </template>

    <template #page-meta>
      Enter your Phone Number
    </template>

    <template #page-body>
      <div class="auth text-center">
        <div class="pin">
          <div class="pin-win">
            <span>533-122-0443</span>
          </div>

          <div class="pin-keyboard">
            <ul class="pin-list">
              <li><span class="pin-key">1</span></li>
              <li><span class="pin-key">2</span></li>
              <li><span class="pin-key">3</span></li>

              <li><span class="pin-key">4</span></li>
              <li><span class="pin-key">5</span></li>
              <li><span class="pin-key">6</span></li>

              <li><span class="pin-key">7</span></li>
              <li><span class="pin-key">8</span></li>
              <li><span class="pin-key">9</span></li>

              <li><span class="pin-key">0</span></li>

              <li><span class="pin-key pin-key_call">Clear</span></li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </cd-layout>
</template>
<script>
import CdLayout from '../layouts/CdLayout'

export default {
  name: 'Phone',
  components: {
    CdLayout
  },
  data () {
    return {}
  },
  methods: {},
  computed: {}
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/Phone.vue